module.exports = __webpack_public_path__ + "img/checklist.2d4f63d2.svg";